import { cn } from '@/lib/utils';
import type { CSSProperties } from 'react';

export interface SiriOrbColors {
  bg?: string;
  c1?: string;
  c2?: string;
  c3?: string;
}

export interface SiriOrbProps {
  size?: string;
  className?: string;
  colors?: SiriOrbColors;
  animationDuration?: number;
}

/**
 * Fluid gradient orb (Siri-style). Styles in `index.css` (`.siri-orb`, `--siri-*`).
 */
export function SiriOrb({
  size = '192px',
  className,
  colors,
  animationDuration = 20,
}: SiriOrbProps) {
  const defaultColors = {
    bg: 'transparent',
    c1: 'var(--siri-orb-c1)',
    c2: 'var(--siri-orb-c2)',
    c3: 'var(--siri-orb-c3)',
  };

  const finalColors = { ...defaultColors, ...colors };
  const sizeValue = parseInt(size.replace('px', ''), 10) || 192;
  const blurAmount = Math.max(sizeValue * 0.08, 8);
  const contrastAmount = Math.max(sizeValue * 0.003, 1.8);

  const style = {
    width: size,
    height: size,
    '--siri-bg': finalColors.bg,
    '--siri-c1': finalColors.c1,
    '--siri-c2': finalColors.c2,
    '--siri-c3': finalColors.c3,
    '--siri-animation-duration': `${animationDuration}s`,
    '--siri-blur-amount': `${blurAmount}px`,
    '--siri-contrast-amount': contrastAmount,
  } as CSSProperties;

  return <div className={cn('siri-orb', className)} style={style} aria-hidden />;
}
